import { NotFound } from "@/pages/NotFound";
import { Route, Routes } from "react-router-dom";
import { DashBoardLayout } from "../layouts/DashBoardLayout/DashBoardLayout/DashBoardLayout";

import { DefaultLoader } from "@/components/loaders/DefaultLoader/DefaultLoader";
import { ComponentType, lazy, Suspense } from "react";

const General = lazy(() =>
  import("@/pages/General").then((module) => ({
    default: module.General as ComponentType,
  })),
);

const Wines = lazy(() =>
  import("@/pages/Wines").then((module) => ({
    default: module.Wines as ComponentType,
  })),
);

const Fairs = lazy(() =>
  import("@/pages/Fairs").then((module) => ({
    default: module.Fairs as ComponentType,
  })),
);

const Addresses = lazy(() =>
  import("@/pages/Addresses/Addresses").then((module) => ({
    default: module.Addresses as ComponentType,
  })),
);

const Tours = lazy(() =>
  import("@/pages/Tours/Tours").then((module) => ({
    default: module.Tours as ComponentType,
  })),
);

const PagesVideo = lazy(() =>
  import("@/pages/PagesVideo/PagesVideo").then((module) => ({
    default: module.PagesVideo as ComponentType,
  })),
);

const Reviews = lazy(() =>
  import("@/pages/Reviews/Reviews").then((module) => ({
    default: module.Reviews as ComponentType,
  })),
);

const Panel = lazy(() =>
  import("@/pages/AdminPanel/Panel").then((module) => ({
    default: module.Panel as ComponentType,
  })),
);

export function AppRoutes() {
  return (
    <Routes>
      <Route element={<DashBoardLayout />}>
        <Route index element={<General />} />
        <Route
          path="wines"
          element={
            <Suspense fallback={<DefaultLoader elementIsReady={false} />}>
              <Wines />
            </Suspense>
          }
        />

        <Route
          path="fairs"
          element={
            <Suspense fallback={<DefaultLoader elementIsReady={false} />}>
              <Fairs />
            </Suspense>
          }
        />

        <Route
          path="addresses"
          element={
            <Suspense fallback={<DefaultLoader elementIsReady={false} />}>
              <Addresses />
            </Suspense>
          }
        />

        <Route
          path="tours"
          element={
            <Suspense fallback={<DefaultLoader elementIsReady={false} />}>
              <Tours />
            </Suspense>
          }
        />

        <Route
          path="video_pages"
          element={
            <Suspense fallback={<DefaultLoader elementIsReady={false} />}>
              <PagesVideo />
            </Suspense>
          }
        />

        <Route
          path="reviews"
          element={
            <Suspense fallback={<DefaultLoader elementIsReady={false} />}>
              <Reviews />
            </Suspense>
          }
        />

        <Route
          path="adminPanel"
          element={
            <Suspense fallback={<DefaultLoader elementIsReady={false} />}>
              <Panel />
            </Suspense>
          }
        />

        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}
